import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Oauth2Service } from '@bytel/checkout';

import { HTTP_ERROR_PREFIX } from '@base/common/constants/index';
import { Oauth2ResourcesService } from '@base/common/oauth2/oauth2-resources.service';
import { BtlPrismeService } from '@base/common/services/btl-prisme.service';

import { Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

import { BasicObject } from '../interfaces/checkout.interface';

@Injectable({
    providedIn: 'any',
})
export class CheckoutOauth2ResourcesService extends Oauth2ResourcesService {
    public errorSubject: Subject<HttpErrorResponse> = new Subject<HttpErrorResponse>();
    public lockedSubject$: Subject<boolean> = new Subject<boolean>();
    private _displayErrors: boolean = false;

    constructor(
        protected oauth2: Oauth2Service,
        protected http: HttpClient,
        protected prismeService: BtlPrismeService,
    ) {
        super(oauth2, http, prismeService);
    }

    public displayErrors(): this {
        this._displayErrors = true;
        return this.getInstance();
    }

    public isError(httpError: HttpErrorResponse, httpErrorType: HTTP_ERROR_PREFIX): boolean {
        return httpError.status.toString().startsWith(httpErrorType);
    }

    protected getInstance(): this {
        const instance: this = super.getInstance();
        instance.errorSubject = this.errorSubject;
        instance.lockedSubject$ = this.lockedSubject$;
        return instance;
    }

    protected getRequest(httpMethod: string, body?: BasicObject): any {
        const obs = super.getRequest(httpMethod, body);
        return obs.pipe(
            takeUntil(this.lockedSubject$),
            catchError((res: any) => {
                if (this._displayErrors && res instanceof HttpErrorResponse) {
                    this.errorSubject.next(res);
                }
                throw res;
            }),
        );
    }
}
